import React, { FunctionComponent, ReactElement, memo } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../../utils/PropTypesDefinitions'

export type ScrollToTopButtonProps = {
    /**
     * callback function triggered when button is pressed
     *
     * @TJS-type function
     */
    onPress?: () => void
} & TestID

const ScrollToTopButton: FunctionComponent<ScrollToTopButtonProps> = ({
    onPress,
    testID,
}): ReactElement => {
    return (
        <Touchable onPress={onPress} testID={testID}>
            <Grid
                noExpand
                center
                width={44}
                height={44}
                borderRadius={22}
                elevation={4}
                backgroundColor="onyx"
            >
                <FontelloIcon name="up" color="pearl" fontSize={18} />
            </Grid>
            {/* space for shadow */}
            <Grid noExpand height={4} />
        </Touchable>
    )
}

export default memo(ScrollToTopButton)
